<template>
    <div>
        <div id="paypalButtons" style="text-align: center;"></div>

        <div class="loading  loading--secondary" v-if="loading">
            <div class="loading__inner">
                <div class="loading__spinner"></div>
            </div>
        </div>

        <!-- Used to display form errors. -->
        <div id="card-errors" v-if="errors.length > 0" role="alert">
            <p v-for="error in errors" v-html="error"></p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            redirectUrl: {
                type: String,
                default: '/booking/paypal/authorise'
            },
            amount: {
                type: Number,
                default: 1000
            },
            currency: {
                type: String,
                default: 'gbp'
            },
            owner: {
                type: Object,
                required: false
            }
        },

        data: () => ( {
            loading: false,

            paypal: null,

            meta: {
                amount: '10.00',
                currency: this.currency,
                owner: {
                    name: '',
                    email: '',
                    phone: '',
                    address: {
                        line1: '',
                        line2: '',
                        city: '',
                        state: '',
                        postal_code: '',
                        country: '',
                    }
                },
            },

            errors: []
        } ),

        mounted() {
            this.startPaypal()
        },

        methods: {
            startPaypal() {
                const amount = this.amount / 100;
                // Create a paypal client.
                this.paypal = window.paypal;

                let vm = this;

                this.paypal.Buttons( {
                    createOrder( data, actions ) {
                        return actions.order.create( {
                            purchase_units: [ {
                                amount: {
                                    currency_code: this.currency,
                                    value: amount
                                },
                            } ],
                        } )
                    },
                    onApprove( data, actions ) {
                        vm.loading = true;

                        return actions.order.capture().then( ( details ) => {
                            return axios.post( '/booking/paypal/validate', { id: data.orderID } )
                                .then( response => {
                                    if ( response.data.result.status === "COMPLETED" || response.data.result.status === "APPROVED" ) {
                                        axios.post( '/booking/paypal/pay', {
                                            id: data.orderID,
                                            address: {
                                                line_1: response.data.result.purchase_units[ 0 ].shipping.address.address_line_1,
                                                county: response.data.result.purchase_units[ 0 ].shipping.address.admin_area_1,
                                                city: response.data.result.purchase_units[ 0 ].shipping.address.admin_area_2,
                                                country: response.data.result.purchase_units[ 0 ].shipping.address.country_code,
                                                postcode: response.data.result.purchase_units[ 0 ].shipping.address.postal_code,
                                                name: response.data.result.purchase_units[ 0 ].shipping.name.full_name
                                            },
                                            amount: amount
                                        } )
                                            .then( response => {
                                                if ( response.data.url ) {
                                                    window.location.replace( response.data.url )
                                                } else {
                                                    vm.errors.push( 'You could not be charged at this time.' );
                                                }

                                                vm.loading = false
                                            } )
                                    } else {
                                        vm.errors.push( 'You could not be charged at this time.' );
                                    }

                                } )
                                .catch( error => {
                                    vm.errors.push( 'You could not be charged at this time.' );
                                } );
                        } );
                    },
                    onError( err ) {
                        vm.loading = false;

                        vm.errors.push( 'You could not be charged at this time.' );
                    }
                } ).render( '#paypalButtons' );
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Checkout/Gateway/PayPal.vue